module.exports = "<ng-container *ngComponentOutlet=\"component\">\n</ng-container>\n"